export const DEFAULT_RISK_MODEL = {
  productId: null,
  productVersion: '',
  orgId: null,
  reqName: null,
  reqId: null,
  riskName: '',
  riskDescription: '',
  riskCategorization: '',
  riskType: '',
  regulations: [],
  source: 'employee',
  mitigationStatus: 'A',
  mitigationStrategy: '',
  mitigationStrategyAI: '',
  measurableParameters: [],
  validationTestNum: '',
  validationStatus: '',
  verificationTestNum: '',
  verificationStatus: '',
  aiScores: {
    detectability: 0,
    probability: 0,
    severity: 0,
    riskScore: 0,
    detectabilityFm: 0,
    probabilityFm: 0,
    severityFm: 0,
    riskScoreFm: 0
  },
  riskScores: {
    detectability: 0,
    probability: 0,
    severity: 0,
    riskScore: 0,
    detectabilityFm: 0,
    probabilityFm: 0,
    severityFm: 0,
    riskScoreFm: 0
  },
  additionalInfo: {
    reference: '',
    involvesSw: false,
    potentialOrExistingCauses: '',
    possibleHarmCaused: '',
    reviewed: 'NO'
  },
  actions: [],
  documents: [],
  notes: ''
};

export const MITIGATION_STATUS_OPTIONS = [
  { value: 'A', label: 'A' },
  { value: 'B', label: 'B' },
  { value: 'C', label: 'C' }
];

export const AI_RISK_SYMBOL = '⃰';

export const DEFAULT_ACTIVITY_MODEL = {
  activityId: null,
  name: '',
  title: '',
  description: '',
  status: 'To Do',
  users: [],
  isAISelected: false
};

export const SCORE_KEYS = [
  'detectability',
  'probability',
  'severity',
  'riskScore',
  'detectabilityFm',
  'probabilityFm',
  'severityFm',
  'riskScoreFm'
];

export const RISK_TOGGLE_OPTIONS = [
  'Risk Score Distribution - Before Mitigation',
  'Risk Score Distribution - After Mitigation'
];

export const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

export const RISK_DISTRIBUTION_COLORS = [
  // 4 greens
  '#6fbf72',
  '#5db761',
  '#4CAF50',
  '#449d48',
  // 2 oranges
  '#ffaf3b',
  '#e88a2e',
  // 16 reds
  '#ff3232',
  '#ff3232',
  '#ff1919',
  '#ff1919',
  '#ff0000',
  '#ff0000',
  '#e50000',
  '#e50000',
  '#cc0000',
  '#cc0000',
  '#b20000',
  '#b20000',
  '#990000',
  '#990000',
  '#7f0000',
  '#7f0000'
];

export const TASK_TYPE_OPTIONS = [
  { value: 'Risk review meetings', label: 'Risk review meetings' },
  { value: 'Risk mitigation execution', label: 'Risk mitigation execution' },
  { value: 'Ongoing risk monitoring', label: 'Ongoing risk monitoring' }
];